import { DatalayerService } from '@analytics/datalayer';
import { NavigationEventsService } from '@analytics/events';
import { DOCUMENT } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { PlatformService } from '@core/platform';

@Component({
  selector: 'wl-analytics-setup',
  template: '',
  standalone: true,
})
export class AnalyticsSetupComponent implements OnInit {
  readonly #document = inject(DOCUMENT);
  readonly #platform = inject(PlatformService);
  readonly #datalayer = inject(DatalayerService);
  readonly #navigationEvents = inject(NavigationEventsService);

  async ngOnInit() {
    this.#navigationEvents.trackNavigationEvents();
    this.#datalayer.init();

    if (this.#platform.isClient()) {
      this.#document.body.dispatchEvent(new CustomEvent('AngularLoaded'));
    }
  }
}
